module.exports = __webpack_public_path__ + "static/media/8.f7f254e2.svg";